import React, {useEffect} from 'react';
import { connect } from 'react-redux';
import { verifyUserValidity, getOnlineStatusUpdate, showAlertModal } from './actions';
import SideBar from './components/nav/sidebar';
import Header from './components/nav/header/Header';
import Live from './components/live';
import Playback from './components/playback';
import Admin from './components/admin';
import Utilities from './components/utilities';
import './App.css';
import Dialog from './components/common/Dialog';

const Main = props => {
  const {
    view,
    alertModal,
    deviceIdList,
    devices,
    cameras,
    user,
    token,
    verifyUserValidity,
    getOnlineStatusUpdate,
    showAlertModal,
  } = props

  useEffect(() => {
    const updateTimer = setInterval(async () => {
      // verify if user data is still valid, if not, force logout
      await verifyUserValidity(deviceIdList, user)

      if (view === 'live' || view === 'playback') {
        // get updated device/camera online status
        await getOnlineStatusUpdate(deviceIdList, token, devices, cameras)
      }
    }, 60000) // in ms

    return () => clearInterval(updateTimer)

  // eslint-disable-next-line
  }, [deviceIdList, user, view])

  const closeAlert = () => {
    // if we are editing a form put focus back to the form so onblur will work
    document.getElementById('form-wrapper') && document.getElementById('form-wrapper').focus()
    showAlertModal([])
  }

  return (
    <div style={styles.container}>
      <Header />

      <div style={styles.body}>
        {/* view will eather be one of these only for now */}
        {view === 'live' && <Live />}
        {view === 'playback' && <Playback />}
        {view === 'admin' && <Admin />}
        {view === 'utilities' && <Utilities />}

        <SideBar />
      </div>

      {alertModal && alertModal.length !== 0 &&
        <Dialog
          overlayStyle  = {{zIndex: 10000}}
          title         = {alertModal[0]}
          content       = {alertModal[1]}
          buttons       = {[{label: 'OK', onClick: closeAlert}]}
        />
      }
    </div>
  )
}

const mapStateToProps = (state) => {
  const { view, alertModal } = state.config
  const { deviceIdList, devices, cameras } = state.data
  const { user, token } = state.auth

  return {
    view,
    alertModal,
    deviceIdList,
    devices,
    cameras,
    user,
    token,
  }
}
export default connect(mapStateToProps, { verifyUserValidity, getOnlineStatusUpdate, showAlertModal } )(Main)

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 5vw',
    position: 'relative',
  },
  body: {
    display: 'flex',
    flexDirection: 'row',
    height: '85vh',
    marginBottom: '5vh',
  },
};